import React from "react";
import { Route } from "react-router-dom";
import SelectLogin from "./oauth-select-login/select-login";
import OauthRegisterPc from "./oauth-register-pc";
import { OauthLoginMSAL } from "./oauth-login-msal/oauth-login-msal";

const prefix = "/oauth";

const routes = [
  <Route
    path={`${prefix}/register-machine`}
    component={OauthRegisterPc}
    exact
    key={`${prefix}-register-machine`}
  />,
  <Route
    path={`${prefix}/select-login-type`}
    component={SelectLogin}
    exact
    key={`${prefix}/select-login-type`}
  />,
  <Route
    path={`${prefix}/login-msal`}
    component={OauthLoginMSAL}
    exact
    key={`${prefix}/login-msal`}
  />,
];

export default routes;
